"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggler = exports.DROPDOWN_TOGGLER_STYLE_TYPE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Toggler.scss");
let DROPDOWN_TOGGLER_STYLE_TYPE = exports.DROPDOWN_TOGGLER_STYLE_TYPE = /*#__PURE__*/function (DROPDOWN_TOGGLER_STYLE_TYPE) {
  DROPDOWN_TOGGLER_STYLE_TYPE["button"] = "button";
  DROPDOWN_TOGGLER_STYLE_TYPE["icon"] = "icon";
  return DROPDOWN_TOGGLER_STYLE_TYPE;
}({});
const Toggler = _ref => {
  let {
    className,
    dataAttributes,
    icon,
    label,
    onClick,
    styleType = DROPDOWN_TOGGLER_STYLE_TYPE.icon,
    withArrow = true,
    setRef
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Dropdown-Toggler', {
    'cds-Dropdown-Toggler--Button': styleType === DROPDOWN_TOGGLER_STYLE_TYPE.button
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, dataAttributes, {
    className: rootClassName,
    onClick: onClick,
    ref: setRef
  }), icon && styleType === DROPDOWN_TOGGLER_STYLE_TYPE.icon && /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    className: "cds-Dropdown-Toggler-ButtonIcon",
    icon: icon,
    size: _ButtonIcon.BUTTON_ICON_SIZE.small
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Dropdown-Toggler-ButtonLabel"
  }, label), withArrow && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-Dropdown-Toggler-IconArrowDown",
    name: _Icon.ICON_NAME.arrowDown,
    size: _Icon.ICON_SIZE.xsmall
  }));
};
exports.Toggler = Toggler;
//# sourceMappingURL=Toggler.js.map